<template>
  <div v-if="isPC" class="loginPC">
    <div class="login">
      <div class="loginBox">
        <h2 class="loginH2">
          <strong>远望谷</strong>-门户
        </h2>
        <div class="loginCon">
          <!-- 账号登录 -->
          <el-form ref="loginForm" :rules="rules" :model="ruleForm" style="padding: 0 25px 5px 25px;">
            <el-form-item prop="username" label="用户名">
              <el-input placeholder="请输入账号" prefix-icon="el-icon-user" v-model="ruleForm.username"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
              <el-input
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  v-model="ruleForm.password"
                  show-password
                  clearable
              ></el-input>
            </el-form-item>
            <el-button type="primary" class="loginBtn" @click="loginYz('loginForm')">登录</el-button>
          </el-form>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="phonePg">
    <van-form @submit="loginYz" class="login_form">
      <img src="../../assets/logo/logo_all.png" alt="logo" class="logoImg">
      <van-field
          v-model="ruleForm.username"
          name="用户名"
          label="用户名"
          placeholder="用户名"
          :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
          v-model="ruleForm.password"
          clearable
          type="password"
          name="密码"
          label="密码"
          placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]"
      />
      <div>
        <van-button class="submitBtn" color="#2ad1c4" round type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>

</template>

<script>

import store from "@/store";
import { currencyRoutes, authRoutes, phoneCurrencyRoutes,phoneAuthRoutes } from "@/router";
import  router from "@/router";
import { isPC } from '../../utils/browser.js';
import { Form, Button, Field } from "vant";
import {  Message } from 'element-ui' // 引用element-ui的加载和消息提示组件
import { Toast } from 'vant'
import {getInfo} from "@/api/login"; // 引用element-ui的加载和消息提示组件
const isPCPort = isPC();

export default {
  data() {
    return {
      isPC: this.$store.state.isPC || isPC(),
      ruleForm: {
        username: null,
        password: null
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
    };
  },
  methods: {

    loginYz(form) {
      const _this = this;
      // 点击登录
      if(this.isPC){
        _this.$refs[form].validate(valid => {
          if (valid) {
            _this._login();
          } else {
            return;
          }
        });
      }else {
        console.log(_this.ruleForm.username,_this.ruleForm.password)
        _this._login();
      }



    },
    _login() {
      // 此处获取token,commit到store中
      const _this = this;
      this.$store.dispatch("user/_login", this.ruleForm).then(res => {
        if(_this.isPC){
          _this.$router.push('/dashbord')
        } else {
          _this.$router.push('/phoneIndex')
        }
      }).catch(error => {
        if(isPCPort && error){
          Message.error(error.msg)
        } else {
          error && Toast.fail(error.msg)
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">

.loginPC {
  width: 100%;
  height: 100%;
}
.login {
  height: 100%;
  width: 100%;
  background: url("../../assets/login/loginBg.jpg") no-repeat;
  background-size: auto 100%;
}
.loginBox {
  background: url("../../assets/login/login_form.png") no-repeat;
  background-size: 100% 100%;
  height: 455px;
  width: 395px;
  position: relative;
  top: 30%;
  left: calc(70% - 150px);
  padding: 10px 30px
}
.loginH2 {
  color: #02c8f4;
  font-size: 40px;
  text-align: center;
  margin-top: 20px;
}
.loginCon {
  margin-top: 30px;
  background: transparent;
  border-radius: 4px;
  .el-form {
    padding: 25px 25px 30px 25px;
    border-radius: 0 0 4px 4px;
  }
}
.phonePg {
  width: 100%;
  height: 100vh;
  background-color: #8dd3ce
}

.loginBtn {
  background: #19b9e7;
  border: none;
  font-size: 20px;
  position: relative;
  left: calc(50% - 60px);
  width: 120px;
  top: 20px;
}

.login_form {
  width: 70%;
  margin: 0 auto;
  border: 1px solid #2ad1c4;
  padding: 7% 5%;
  border-radius: 20px;
  box-shadow: 0px 0 15px #333333;
  position: relative;
  top: 20vh;
  background-color: #ffffff;
}

.logoImg {
  width: 50%;
  height: auto;
  display: block;
  margin: auto;
}

.submitBtn {
  width: 60%;
  margin: 30px auto 20px auto;
  display: block;
}



</style>

<style>
.loginCon .el-form-item__label {
  font-size: 18px;
}

.loginCon .el-input__inner {
  font-size: 18px;
}


.loginCon .el-form-item {
  border: none;
}

.phonePg .van-cell {
  border: 1px solid #2ad1c4;
  margin-top: 30px;
  border-radius: 30px;
}

/*.phonePg .van-field__control{*/
/*  display: none;*/
/*}*/

.phonePg .van-field--error .van-field__control::placeholder {
  display: none;
}
</style>
